import { ENV } from "config/configUrl";

// Currencies an order or a payment link can be paid in (those the API takes payment
// in). USDT has no testnet contract: on staging the API refuses it.
const allPaymentCurrencies = [
  { id: "btc", name: "BTC" },
  { id: "eth", name: "ETH" },
  { id: "usdc", name: "USDC" },
  { id: "usdt", name: "USDT" },
  { id: "sol", name: "SOL" },
  { id: "pol", name: "POL" },
  { id: "avax", name: "AVAX" },
];

// Production offers ETH and USDC only; other environments offer every currency.
const PRODUCTION_CURRENCIES = ["eth", "usdc"];

export const paymentCurrencyChoices =
  (ENV as string) === "production"
    ? allPaymentCurrencies.filter((currency) => PRODUCTION_CURRENCIES.includes(currency.id))
    : allPaymentCurrencies;
